WiseMetering.Views.ShowDatelkaIntegration = WiseMetering.Views.Content.extend({
    icon: 'wiseStore',

    initialize({ model, view }) {
        const partner = model.partner();
        this.name = `${partner.get('name')} > ${this.model.get('name')}`;

        this.tabs = [
            {
                active: view === 'details',
                href: `/integrations/${model.id}/details`,
                id: 'details',
                name: i18next.t('common.details'),
                view: WiseMetering.Views.DatelkaDetails
            }
            // {
            //     active: view === 'data',
            //     href: `/integrations/${model.id}/data`,
            //     id: 'data',
            //     name: i18next.t('common.data'),
            //     view: WiseMetering.Views.DatelkaData
            // }
        ];

        if (WiseMetering.currentUser.get('superuser')) {
            this.tabs.push({
                active: view === 'logs',
                href: `/integrations/${model.id}/logs`,
                id: 'logs',
                name: i18next.t('glossary.logs'),
                view: WiseMetering.Views.IntegrationLogs
            });

            this.tabs.push({
                active: view === 'raw_data',
                href: `/integrations/${model.id}/raw_data`,
                id: 'raw-data',
                name: i18next.t('glossary.raw_data'),
                view: WiseMetering.Views.IntegrationRawData
            });
        }
    }
});
